import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getRouteData, reverseString } from '@mwe/utils';
import { KundenTypEnum } from '@mwe/models';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentService } from '@mwe/services';

@Injectable()
export abstract class CorrelationIdInterceptor implements HttpInterceptor {
  private readonly activatedRoute = inject(ActivatedRoute);

  protected abstract getCustomerType(): KundenTypEnum;
  private readonly envService = inject(EnvironmentService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const routeData = getRouteData(this.activatedRoute);
    if (req.url.indexOf('auth/realms/logwien') === -1) {
      const modifiedReq = req.clone({
        headers: req.headers
          .set('x-correlationId', routeData?.isLandingPage ? this.getCorrelationId('LP-') : this.getCorrelationId())
          .set('x-app-version', this.getAppVersion())
          .set('x-customerType', this.getCustomerType()),
      });
      return next.handle(modifiedReq);
    }
    return next.handle(req);
  }

  private getCorrelationId(prefixOverwrite?: string): string {
    const prefix = prefixOverwrite || this.getApplicationPrefix();
    return prefix + reverseString('' + new Date().getTime());
  }

  private getAppVersion(): string {
    return this.envService.getEnvironment().appVersion;
  }
  protected getApplicationPrefix(): string {
    return '';
  }
}
